<ng-container *transloco="let t">
    <div class="toolbar">
        <mat-toolbar class="toolbar-heading" role="heading" aria-level="1">
            <div fxHide.gt-sm>
                <button
                    mat-icon-button
                    (click)="onToggleSidenav()"
                    class="menu-button"
                >
                    <mat-icon>menu</mat-icon>
                </button>
            </div>

            <div class="logo" (click)="navigation('home')">
                <ng-container *ngIf="clientLogoPath">
                    <span class="mat-button-wrapper literacy-pro-img">
                        <img src="{{ clientLogoPath }}" alt="Literacy Pro" />
                    </span>
                    <span class="header-line"></span>
                </ng-container>

                <span class="mat-button-wrapper literacy-pro-img">
                    <img src="assets/img/Literacy Pro.svg" />
                </span>
            </div>

            <div fxFlex fxLayout fxLayoutAlign="end" fxHide.lt-md>
                <ul fxLayout fxLayoutGap="5px" class="navigation-items">
                    <ng-container
                        *ngIf="
                            clientIsEnabled &&
                            router.url.includes('/home') &&
                            !router.url.includes('/provider')
                        "
                    >
                        <li fxLayoutAlign="stretch">
                            <button
                                mat-button
                                (click)="navigation('provider')"
                                class="link-button"
                            >
                                {{
                                    t("shared.link.find-a-provider") | uppercase
                                }}
                            </button>
                            <div></div>
                        </li>
                    </ng-container>

                    <li fxLayoutAlign="stretch">
                        <button
                            mat-button
                            (click)="navigation('help-and-support')"
                            class="link-button"
                        >
                            {{ t("shared.link.help-and-support") | uppercase }}
                        </button>
                    </li>

                    <ng-container *ngIf="clientIsEnabled && !isSignedIn">
                        <li fxLayoutAlign="stretch">
                            <button
                                mat-flat-button
                                (click)="signIn()"
                                class="account-button"
                            >
                                {{ t("shared.link.sign-in") | uppercase }}
                            </button>
                        </li>
                    </ng-container>

                    <ng-container *ngIf="isSignedIn">
                        <li fxLayoutAlign="stretch">
                            <button
                                class="link-button"
                                mat-button
                                [matMenuTriggerFor]="userMenu"
                            >
                                {{ (user$ | async)?.displayName }}
                            </button>
                            <mat-menu #userMenu="matMenu">
                                <button
                                    mat-menu-item
                                    (click)="navigation('account')"
                                    class="account-button"
                                >
                                    {{
                                        t("shared.link.my-account") | uppercase
                                    }}
                                </button>
                                <button
                                    mat-menu-item
                                    (click)="signOut()"
                                    class="account-button"
                                >
                                    {{ t("shared.link.sign-out") | uppercase }}
                                </button>
                            </mat-menu>
                        </li>
                    </ng-container>

                    <li fxLayoutAlign="stretch">
                        <button
                            mat-button
                            [matMenuTriggerFor]="menu"
                            class="language-dropdown"
                        >
                            <mat-icon>language</mat-icon>
                            {{ selectedLanguageName | uppercase }}
                            <span class="expand-icon"
                                ><mat-icon>expand_more</mat-icon></span
                            >
                        </button>
                        <mat-menu #menu="matMenu">
                            <button
                                mat-menu-item
                                *ngFor="let language of languages"
                                (click)="selectLanguage(language.code)"
                            >
                                {{ language.name }}
                            </button>
                        </mat-menu>
                    </li>
                </ul>
            </div>
        </mat-toolbar>
    </div>
</ng-container>
